<div class="channelDiv">
    <div class="channelSubscriptionDiv">
        <div class="logoAndChannel">
            <img src="../../assets/img/logoSubscriptionPart.png" alt="logo">
            <div class="channelAndIcon">
                <div class="channelSubscription"> Metl.tv Channel Subscribtion</div>
                <img src="../../assets/img/rocket.png" alt="rocket">
            </div>
        </div>
    </div>
    <div class="channelBelowDiv">
        <div class="chooseTrier">Choose Trier for Subscrition</div>
        <div class="subscriptionText">With Metl.tv Channel subscribtion gets even better with features you can't get
            anywhere else.
        </div>
        <div class="cardDivs">
            <div class="cardDiv" *ngFor="let plan of planList;let i = index">
                <div class="cardPart1">
                    <img [src]=planListImg[i].img alt="bronzeFrame">
                    <div class="cardTitle">{{plan.name}}</div>
                </div>
                <div class="cardText">{{plan.description}}</div>
                <div class="cardPart2">
                    <div class="cardLeftPart">
                        <div class="cardLeftPart1">{{plan.name}}</div>
                        <div class="cardLeftPart2">${{plan.cost}} / Month</div>
                    </div>
                    <button class="cardRightPartBtn" (click)="goToPlanChanel(plan.permissions,plan.cost,plan.id)">View
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
